import images from './images';

const juice = [
  {
    title: 'Mango Shake',
    price: 'Rs50',
    tags: 'AU | Glass',
  },
  {
    title: 'Banana Shake',
    price: 'Rs59',
    tags: 'AU | Glass',
  },
  {
    title: 'Coca-Cola',
    price: 'Rs44',
    tags: 'FR | 750 ml',
  },
  {
    title: 'Lassi',
    price: 'Rs31',
    tags: 'AU | Glass',
  },
  {
    title: 'Cold-Coffee',
    price: 'Rs26',
    tags: 'AU | Glass',
  },
  {
    title: 'Hot-Coffee',
    price: 'Rs26',
    tags: 'AU | Glass',
  },
];

const food = [
  {
    title: 'Dosa',
    price: 'Rs20',
    tags: 'Masala | Plain| Paneer Stuffed | Shmbhar | Chutni',
  },
  {
    title: "Idlli",
    price: 'Rs16',
    tags: 'Rawa Idlli | Plain Idlli |Sambhar | Chutni',
  },
  {
    title: 'Choole Bhature',
    price: 'Rs70',
    tags: 'Cholle | Bahture | Achar | Sallad',
  },
  {
    title: 'Manchurian Rice',
    price: 'Rs31',
    tags: 'Fried Rice | Plain Rice| Chilli Manchurian',
  },
  {
    title: 'Naan with Paneer',
    price: 'Rs31',
    tags: 'Fried Rice | Plain Rice| Roti',
  }
];


export default { juice, food };